import { FormControl, MenuItem, Select } from '@mui/material'
import React from 'react'
import { PERIODS, PERIOD } from '../../enums/StatsTimes.enum'
import { toNumber } from 'lodash'
import { t } from 'i18next'
type StatsTimeSelectorProps = {
    periods: typeof PERIODS,
    selectedPeriod: number,
    onPeriodChange: (period: number) => void
}
function StatsTimeSelector({ periods, selectedPeriod, onPeriodChange }: StatsTimeSelectorProps) {
    return (
        <FormControl sx={{ width: '250px' }} >
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={selectedPeriod}
                onChange={(e) => onPeriodChange(e.target.value ? toNumber(e.target.value) : 0)}
            >
                {
                    periods.map(period => <MenuItem value={period.value} key={period.value}>{t(period.text)}</MenuItem>)
                }

            </Select>
        </FormControl>
    )
}

export default StatsTimeSelector